import { useState, useEffect } from 'react';
export const useLocalStorage = (key, defaultValue) => {
    const [value, setValue] = useState(() => {
        let currentValue;
        try {
            currentValue = JSON.parse(localStorage.getItem(key) || JSON.stringify(defaultValue));
        }
        catch (_a) {
            currentValue = defaultValue;
        }
        return currentValue;
    });
    useEffect(() => {
        localStorage.setItem(key, JSON.stringify(value));
    }, [value, key]);
    return [value, setValue];
};
